import _ from '@lodash';
import LoadingDialog from 'app/admin/common/LoadingDialog';
import { useDispatch, useSelector } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { Tooltip, Icon, IconButton } from '@material-ui/core';
import { useState } from 'react';
import VizsgaFeladatsorService from '../service/VizsgaFeladatsorService';

function TableToolbarPermutationButton(props) {
	const dispatch = useDispatch();
	const [disabled, setDisabled] = useState(false);
	const [loading, setLoading] = useState(false);
	const filterList = useSelector(rootState => rootState.vizsgaFeladatsorTable.tableBrowserFilter.filterList);

	const handleClick = () => {
		const vizsgaVizsgasor = filterList.find(item => item.propertyName === 'vizsgaVizsgasor');
		if (!_.isUndefined(vizsgaVizsgasor)) {
			setDisabled(true);
			setLoading(true);
			VizsgaFeladatsorService.generatePermutation(vizsgaVizsgasor)
				.then(response => {
					if (response.successful) {
						dispatch({ type: 'vizsgaFeladatsorTable/event/setNeedDataReload' });
						dispatch(showMessage({ message: 'Permutálás sikeresen végrehajtva.' }));
					} else {
						const propKeys = Object.keys(response.properties);
						if (propKeys.length > 0) {
							dispatch(showMessage({ message: response.properties[propKeys[0]][0].message }));
						} else {
							dispatch(showMessage({ message: 'Permutálás nem végrehajtható, vagy hiba történt.' }));
						}
					}
					setDisabled(false);
					setLoading(false);
				})
				.catch(() => {
					setLoading(false);
					dispatch(showMessage({ message: 'Permutálás nem végrehajtható, vagy hiba történt.' }));
					setDisabled(false);
				});
		} else {
			dispatch(showMessage({ message: 'Kérem válasszon ki egy vizsgasort a szűrők között.' }));
		}
	};
	return (
		<>
			<Tooltip title="Permutálás">
				<IconButton onClick={() => handleClick()} disabled={disabled}>
					<Icon fontSize="small">dynamic_feed</Icon>
				</IconButton>
			</Tooltip>
			{loading && <LoadingDialog content="Permutálás folyamatban" />}
		</>
	);
}

export default TableToolbarPermutationButton;
